'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _wholeMinutesOrSeconds = require('../wholeMinutesOrSeconds');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  'warning': 'optix-inactivity-logout-ui__WarningStrap__warning___36VBI',
  'timeRemaining': 'optix-inactivity-logout-ui__WarningStrap__timeRemaining___1Rnut',
  'refreshButtonLink': 'optix-inactivity-logout-ui__WarningStrap__refreshButtonLink___anYSU',
  'refreshButtonIcon': 'optix-inactivity-logout-ui__WarningStrap__refreshButtonIcon___3JWiZ',
  'visuallyhidden': 'optix-inactivity-logout-ui__WarningStrap__visuallyhidden___1pmZR',
  'focusable': 'optix-inactivity-logout-ui__WarningStrap__focusable___3ySiX'
};
var WarningStrap = function (_React$Component) {
  _inherits(WarningStrap, _React$Component);
  function WarningStrap(props) {
    _classCallCheck(this, WarningStrap);
    var _this = _possibleConstructorReturn(this, (WarningStrap.__proto__ || Object.getPrototypeOf(WarningStrap)).call(this, props));
    _this.state = {
      currentAlertMs: props.msUntilLogout
    };
    return _this;
  }
  _createClass(WarningStrap, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var msSinceLastAlert = this.state.currentAlertMs - nextProps.msUntilLogout;
      if (msSinceLastAlert > 14 * 1000) {
        // Only update alert value very 15 seconds
        this.setState({
          currentAlertMs: nextProps.msUntilLogout
        });
      }
      if (msSinceLastAlert < 1) {
        // Timer was refreshed
        this.setState({
          currentAlertMs: nextProps.msUntilLogout
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', {
        className: styles.warning
      }, 'For your safety, you\'ll be logged out in ', _react2.default.createElement('span', {
        className: styles.timeRemaining
      }, (0, _wholeMinutesOrSeconds.wholeMinutesOrSeconds)(this.props.msUntilLogout)), '. ', _react2.default.createElement('button', {
        className: styles.refreshButtonLink
      }, 'Click anywhere to stay logged in.'), _react2.default.createElement('button', {
        className: styles.refreshButtonIcon
      }, '\xD7'), _react2.default.createElement('div', {
        className: styles.visuallyhidden,
        role: 'alert',
        'aria-live': 'assertive'
      }, '\n                        For your safety, you\'ll be logged out in\n                        ' + (0, _wholeMinutesOrSeconds.wholeMinutesOrSeconds)(this.state.currentAlertMs) + '.\n                        Press any key or click anywhere to stay logged in.\n                    '));
    }
  }]);
  return WarningStrap;
}(_react2.default.Component);
exports.default = WarningStrap;
WarningStrap.propTypes = {
  msUntilLogout: _propTypes2.default.number.isRequired
};